import { render } from "./Error.vue?vue&type=template&id=d4212a52"
const script = {}

import exportComponent from "C:\\Users\\Loïc\\Downloads\\smsyou\\avalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__